// extracted by mini-css-extract-plugin
export var searchHeader = "_21-0";
export var searchHeaderDark = "_21-1";